import React from 'react'

const Drivers = () => {
    return (
        <div>Drivers</div>
    )
}

export default Drivers
